/**
 * Validation messages used across form validation
 * Used in: Various validation components and utilities
 *
 * Message keys follow the format: formforge.validation.{rule_type}
 *
 * IMPORTANT: All variables must use ICU Message Format syntax
 */
export const validationMessages: Record<string, string> = {
  'Minimum {value} characters required': 'formforge.validation.min_length',
  'Maximum length is {value} characters': 'formforge.validation.max_length',
  'Minimum value is {value}': 'formforge.validation.min_value',
  'Maximum value is {value}': 'formforge.validation.max_value',
  'Minimum value {value} required': 'formforge.validation.min_value_required',
  'Default value {defaultValue} exceeds maximum {maxValue}':
    'formforge.validation.default_exceeds_max',
  Required: 'formforge.validation.required',
  'This field is required': 'formforge.validation.required',
  'Invalid format': 'formforge.validation.invalid_format',
  'Invalid email address': 'formforge.validation.invalid_email',
  'Value must be a number': 'formforge.validation.must_be_number',
  'Value must be positive': 'formforge.validation.must_be_positive',
  'Value must be negative': 'formforge.validation.must_be_negative',
  'Value must be an integer': 'formforge.validation.must_be_integer',
  'Select at least one option': 'formforge.validation.select_at_least_one',
  'You must accept the terms and conditions':
    'formforge.validation.accept_terms',
  'Choose only one option': 'formforge.validation.choose_only_one',
  'Validation failed': 'formforge.validation.failed',
  'This value already exists.': 'formforge.validation.duplicate_value',
  'Duplicate found for combination: {fields}':
    'formforge.validation.duplicate_combination',
} as const;

// Export type for type safety
export type ValidationMessageKey = keyof typeof validationMessages;
